(() => {
 const root=document.querySelector('[data-nv-evening]');if(!root)return;
 const opens=Date.parse(root.dataset.opens),closes=Date.parse(root.dataset.closes);
 const firstEnd=Date.parse(root.dataset.codeFirstEnd);
 const countdown=root.querySelector('[data-evening-countdown]');
 const deadline=root.querySelector('[data-evening-deadline]');
 const clock=root.querySelector('[role="timer"]');
 const units=['hours','minutes','seconds'].map(unit=>root.querySelector(`[data-evening-${unit}]`));
 let timeout;
 function update(){
  clearTimeout(timeout);
  const now=Date.now();
  root.dataset.phase=now<opens?'before':now<closes?'open':'after';
  if(!countdown)return;
  countdown.hidden=!window.nvHasKlaviyoSource();
  if(countdown.hidden||!Number.isFinite(firstEnd)||!Number.isFinite(closes))return;
  const expired=now>=closes,extended=now>=firstEnd;
  const label=expired?(root.dataset.labelExpired||'Platnost 5% kódu skončila'):extended?(root.dataset.labelExtended||'Prodlouženo do 12:00'):'do 1:00';
  if(deadline.textContent!==label)deadline.textContent=label;
  clock.hidden=expired;
  if(!expired){
   const left=Math.max(0,Math.ceil(((extended?closes:firstEnd)-now)/1000));
   const values=[Math.floor(left/3600),Math.floor(left/60)%60,left%60];
   units.forEach((el,i)=>{const value=String(values[i]).padStart(2,'0');if(el.textContent!==value)el.textContent=value});
   if(!document.hidden)timeout=setTimeout(update,1000-now%1000+10);
  }
 }
 update();
 document.addEventListener('visibilitychange',update);
 window.addEventListener('pageshow',update);
 window.addEventListener('storage',event=>{if(event.key==='nv_klaviyo_source'||event.key===null)update()});
 root.addEventListener('click',event=>{
  if(!event.target.closest('.nv-evening__cta')||event.button!==0||event.metaKey||event.ctrlKey||event.shiftKey||event.altKey)return;
  const results=document.querySelector('shop-component');if(!results)return;
  event.preventDefault();event.stopPropagation();
  const margin=parseFloat(getComputedStyle(results).scrollMarginTop)||0;
  window.scrollTo({top:results.getBoundingClientRect().top+window.scrollY-margin,behavior:matchMedia('(prefers-reduced-motion: reduce)').matches?'instant':'smooth'});
 },true);
 const links=[...root.querySelectorAll('[data-evening-filter], [data-evening-tag]')];
 function updateLinks(){const current=new URL(location.href);for(const a of links){const url=new URL(current);url.searchParams.delete('page');url.hash='ResultsList';url.searchParams.set('featured','podekovani');if(a.dataset.eveningTag){url.pathname='/collections/akce/gender:'+encodeURIComponent(a.dataset.eveningTag);a.setAttribute('aria-current',String(decodeURIComponent(current.pathname).includes('gender:'+a.dataset.eveningTag)))}else if(a.dataset.eveningFilter){url.searchParams.set(a.dataset.eveningFilter,a.dataset.eveningValue);a.setAttribute('aria-current',String(current.searchParams.getAll(a.dataset.eveningFilter).includes(a.dataset.eveningValue)))}else{url.pathname='/collections/akce';for(const other of links)if(other.dataset.eveningFilter)url.searchParams.delete(other.dataset.eveningFilter);a.setAttribute('aria-current',String(!current.pathname.includes('/gender:')&&!links.some(l=>l.dataset.eveningFilter&&current.searchParams.has(l.dataset.eveningFilter))))}a.href=url.pathname+url.search+url.hash}}
 const carriedKeys=['featured','priority','view','utm_source','utm_medium','utm_campaign','utm_content','utm_term'];
 document.addEventListener('formdata',event=>{
  if(!event.target.closest('facets-form-component'))return;
  const params=new URL(location.href).searchParams;
  for(const key of carriedKeys)if(params.has(key))event.formData.set(key,params.get(key));
 },true);
 document.addEventListener('click',event=>{
  const a=event.target.closest('a[href]');if(!a||!a.closest('shop-component'))return;
  const url=new URL(a.href,location.href),current=new URL(location.href);
  if(url.origin!==current.origin||url.pathname!==current.pathname)return;
  for(const key of carriedKeys)if(current.searchParams.has(key))url.searchParams.set(key,current.searchParams.get(key));
  a.href=url.href;
 },true);
 document.addEventListener('filter:update',()=>queueMicrotask(()=>{update();updateLinks()}));
 updateLinks();window.addEventListener('popstate',()=>{update();updateLinks()});root.addEventListener('pointerenter',updateLinks);root.addEventListener('focusin',updateLinks);
})();
